import { Injectable } from "@angular/core";


export interface OverLayOption {
    /** ä»çå¬top Window ä¸­çäºä»¶ */
    onlyTopWindow?: boolean;
    /** ä»å¤çæ»è½®æ»å¨äºä»¶ */
    mouseWheel?: boolean;
    mouseDown?: boolean;
    scroll?: boolean;
    mouseUp?: boolean;
    click?: boolean;
}

const OverLayOptionDefaults: OverLayOption = {
    onlyTopWindow: false,
    mouseWheel: true,
    mouseDown: true,
    scroll: false,
    mouseUp: false,
    click: false
}
@Injectable()
export class OverLayHiddenService {
    
    private eventsMap = new WeakMap();

    private iframeEventHandle(el: any, action: 'addEventListener' | 'removeEventListener') {
        const iframes = Array.from(document.querySelectorAll('iframe'));
        if (iframes && iframes.length) {
            let _documentClickEvent = this.eventsMap.get(el);
            for (const iframe of iframes) {
                const iframeDoc = iframe.contentDocument;
                if (iframeDoc) {
                    iframeDoc[action]('mousedown', _documentClickEvent);
                    iframeDoc[action]('mousewheel', _documentClickEvent);
                    iframeDoc[action]('DOMMouseScroll', _documentClickEvent);
                }
            }
        }
    }

    private removeMouseEvent(el: Element) {
        let _documentClickEvent = this.eventsMap.get(el)
        if (_documentClickEvent) {
            document.removeEventListener('mousedown', _documentClickEvent, true);
            document.removeEventListener('mousewheel', _documentClickEvent, true);
            document.removeEventListener('DOMMouseScroll', _documentClickEvent, true);

            if (top !== window) {
                top.document.body.removeEventListener('mousedown', _documentClickEvent, true);
            }

            this.iframeEventHandle(el, 'removeEventListener');
            _documentClickEvent = null;

            this.eventsMap.delete(el);
        }
    }

    destory(el) {
        this.removeMouseEvent(el);
    }

    registerMouseEvent(el: any, _documentClickEvent: (e) => void, options?: OverLayOption) {
        
        // const _documentClickEvent1 = (e) => {
        //     if (e && e.target && e.target.nodeName.toLowerCase() == 'svg') {
        //         return;
        //     }

        //     _documentClickEvent(e);
        // }


        if (this.eventsMap.has(el)) {
            return;
        } else {
            this.eventsMap.set(el, _documentClickEvent);

        }

        if (!options) {
            options = OverLayOptionDefaults;
        } else {
            options = Object.assign( {}, OverLayOptionDefaults, options);
        }


        if (options.onlyTopWindow && top !== window) {
            top.document.body.addEventListener('mousedown', _documentClickEvent, true);
        } else {
            if (options.mouseDown) {
                // æ³¨å mousedown äºä»¶ éèpanel
                document.addEventListener('mousedown', _documentClickEvent, true);
            }

            if (options.mouseWheel) {
                document.addEventListener('mousewheel', _documentClickEvent, true);
                document.addEventListener('DOMMouseScroll', _documentClickEvent, true);
            }

            if (options.scroll) {
                document.addEventListener('scroll', _documentClickEvent, true);
            }

            if (options.mouseUp) {
                document.addEventListener('mouseup', _documentClickEvent);
            }

            if (options.click) {
                document.addEventListener('click', _documentClickEvent);
            }


            if (top !== window) {
                top.document.body.addEventListener('mousedown', _documentClickEvent, true);
            }

            this.iframeEventHandle(el, 'addEventListener');
        }

        return () => {
            this.destory(el);
        }
    }
}